import { StringHelper } from 'app/utility/stringhelper';
import { LookupInternalModel, LookupExternalModel, LookupModel } from './../shared/lookup.model';
import { ContactClass, ContactType, Gender, SalesStatus } from 'app/utility/enums';
import { OpportunityActivityModel } from './opportunityActivity.model';
import { AddressesModel } from './addresses.model';


export class ContactResultModel
{

    public id: string;
    public contactId: string;
    public contactClass: ContactClass;
    public contactType: ContactType;
    public name: string;
    public firstName: string;
    public lastName: string;
    public mobile: string;
    public primaryEmail: string;
    public rowCnt: number;
    public displayName: string;
    public contactTypeCaption: string;
    public salesStatus: SalesStatus;
    public opportunityCount: number;
    public website: string;
    public active: boolean;

    //transient property
    public hide: boolean;

    public getInitials(): string
    {
        if (!this.name || this.name == "") return "-";
        return StringHelper.getInitials(this.name);
    }

}

export class ContactModel
{
    public id: string;
    public contactClass: string;
    public contactType: string;

    public contactSummary: ContactSummaryModel;
    public contactAddresses: AddressesModel;
    public contactGeneral: ContactGeneralModel;
    public contactAdministration: ContactAdministrationModel;
}

export class ContactSummaryModel
{
    public id: string;
    public contactId: string;
    public contactClass: string;
    public contactType: string;
    public name: string;
    public firstName: string;
    public lastName: string;
    public mobile: string;
    public phone: string;
    public otherPhone: string;
    public primaryEmail: string;
    public displayName: string;
    public contactTypeCaption: string;
    public opportunityCount: number;
    public website: string;
    public active: boolean;
}
export class ContactAdminModel
{
    public contactId: string;
    public marketingAllowed: string;
    public marketingLastDate: string;
    public correspondFlags: number;
    public correspondPref: string;
}
export class ContactGeneralModel
{
    public contactId: string;
    public birthDate: Date;
    public dob: string; //yyyy-mm-dd
    public companyNo: string;
    public nzbn: string;
    public fax: string;
    public firstName: string;
    public genderEnum: string;
    public initials: string;
    public jobTitle: string;
    public lastName: string;
    public legalName: string;
    public legalReference: string;
    public licenceCaption: string;
    public licenceNo: string;
    public licenceVer: string;
    public driverLicenseExpiry: Date;
    public ltsaNumber: string;
    public maritalStatusEnum: string;
    public medTraderNumber: string;
    public middleName: string;
    public mobile: string;
    public name: string = "";
    public otherPhone: string;
    public phone: string;
    public preferredName: string;
    public primaryEmail: string;
    public referralMethodId: string;
    public salutationEnum: string;
    public salutationCaption: string;
    public secondaryEmail: string;
    public spouseId: string;
    public employerId: string;
    public taxNumber: string;
    public website: string;
    public spouse: ContactSummaryModel;
    public employer: ContactSummaryModel;
    public referralMethod: LookupExternalModel;

    public gender: LookupModel;
    public maritalStatus: LookupModel;
    public salutation: LookupModel;
}
export class ContactSalesModel
{
    public contactId: string;
}
export class ContactVehiclesModel
{
    public contactId: string;
}
export class ContactOpportunitiesModel
{
    public contactId: string;
    public activities: OpportunityActivityModel[];
}

export class ContactAdministrationModel
{
    active: boolean;
    reference: string;
    accountOwnerId: string;
    salesStatusProspect: boolean;
    salesStatusVehiclePurchase: boolean;
    salesStatusReconditioning: boolean;
    salesStatusFinance: boolean;
    salesStatusInsurance: boolean;
    salesStatusSaleExtras: boolean;
    correspondPreferenceEnum: number;
    correspondEmail: boolean;
    correspondBulkEmail: boolean;
    correspondPhone: boolean;
    correspondSms: boolean;
    correspondMail: boolean;
    marketingAllowed: boolean;
    marketingLastDate: Date;
    comment: string;
    contactGroupIds: string[];
    accountOwner: ContactResultModel;
    correspondPreference: LookupInternalModel;
    contactGroups: LookupModel[];
    lastCampaign: boolean; //transient property
}
